import paths from '../paths';
import { NewsWorkflowClient } from './newsClient';

export const fetchAgriNewsList = async (maxId: string = '') => {
  try {
    const response = await NewsWorkflowClient.post(
      paths.getNewsList(),
      {
        limit:'10',
        query: {
          all: ['KISAN'],
          any: [],
        },
        maxId: maxId,
      },);

    const { data } = response;
    return {
      news: data?.news ?? [],
      maxId: data?.maxId ?? '',
    };
  } catch (e) {
    console.error('Error fetching Agri News:', e);
    throw e;
  }
};
